import React from 'react';
import { VODCSSModules } from 'shared/utils/wix-connect';

import Spinner from 'shared/components/spinner/loading-spinner';

import styles from './mobile-spinner-overlay.styl';

@VODCSSModules(styles)
export default class MobileSpinnerOverlay extends React.Component {
  render() {
    return (
      <div styleName="spinner-container">
        <Spinner styleName="spinner" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/mobile-spinner-overlay/mobile-spinner-overlay.js